import Image from 'next/image';
import React from 'react';
import logoSm from '@/assets/images/logo-sm.png';
import logo from '@/assets/images/logo.png';
import logoDark from '@/assets/images/logo-dark.png';
const LogoBox = () => {
  return <a href="/" className="logo">
      <span className="logo-light">
        <span className="logo-lg"><Image width={130} height={22} src={'https://24agency.ro/_next/static/media/logo.f82758f3.svg'} alt="logo" /></span>
        <span className="logo-sm"><Image width={60} height={28} src={'https://24agency.ro/_next/static/media/logo.f82758f3.svg'} alt="small logo" /></span>
      </span>
      <span className="logo-dark">
        <span className=""><Image width={150} height={80} src={'https://24agency.ro/_next/static/media/logo.f82758f3.svg'} alt="dark logo" /></span>
        <span className="logo-sm"><Image width={28} height={28} src={'https://24agency.ro/_next/static/media/logo.f82758f3.svg'} alt="small logo" /></span>
      </span>
    </a>;
};
export default LogoBox;